import styled, { css } from 'styled-components';
import { SuiLabel } from '@splashthat/sui';
import Frame from 'react-frame-component';

import {
    uiTransitionDurationNormal,
    uiTransitionDurationLong,
    containerBorderRadiusL,
    baseContainerShadowBlur,
} from 'common/styles/variables';
import { fadeIn } from 'common/styles/snippets';
import { BREAKPOINT_HEIGHTS } from '../../contexts/BreakpointManagerContext/constants';

const viewingBreakpointCss = css`
    margin-top: 1rem;
    height: calc(100% - 1rem);
    max-height: ${(props) => BREAKPOINT_HEIGHTS[props.$width]}px;
    width: ${(props) => props.$width}px;
    border-radius: ${containerBorderRadiusL};
`;

export const StyledFrame = styled(Frame)`
    width: 100%;
    height: 100%;
    box-shadow: 0px 0px ${baseContainerShadowBlur} 0px ${(props) => props.theme.palette.grayscale.gray65};
    transition: ${uiTransitionDurationNormal} ease all;
    animation: forwards ${fadeIn} ${uiTransitionDurationLong} cubic-bezier(0.47, 0, 0.75, 0.72);

    ${(props) => props.$width && viewingBreakpointCss};
`;

export const BreakpointPreviewerContainer = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    background: ${(props) => props.theme.palette.grayscale.black};
`;

export const BreakpointTag = styled(SuiLabel)`
    color: ${(props) => props.theme.palette.grayscale.white};
    font-size: 1rem;

    position: absolute;
    transform: rotate(270deg);
    transform-origin: top right;
    white-space: nowrap;

    right: 3rem;
    top: 1.25rem;
`;

export const BreakpointTagContainer = styled.div`
    position: relative;
`;
